export const uploadTypes = Object.freeze({
  DOCUMENT: 'document',
  CHECKLIST: 'checklist',
})
